module.exports = __webpack_public_path__ + "static/media/Street.909a70d9.svg";